export const getDates = (key) => {
  const now = new Date();
  let dates = {
    startDate: `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`,
    endDate: `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`,
  };
  if (key === "today") {
    dates.startDate = `${now.getFullYear()}-${
      now.getMonth() + 1
    }-${now.getDate()}`;
    dates.endDate = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}`;
    return dates;
  } else if (key === "week") {
    dates.startDate = `${now.getFullYear()}-${now.getMonth() + 1}-${
      now.getDate() - 7
    }`;
    return dates;
  } else if (key === "month") {
    dates.startDate = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}`;
    return dates;
  } else if (key === "months-3") {
    dates.startDate = `${now.getFullYear()}-${(now.getMonth() - 2)
      .toString()
      .padStart(2, "0")}-${now.getDate()}`;
    return dates;
  } else if (key === "year") {
    dates.startDate = `${(now.getFullYear() - 1).toString().padStart(2, "0")}-${
      now.getMonth() + 1
    }-${now.getDate()}`;
    return dates;
  }
};
